export default "__VITE_ASSET__BT1zjgQJ__"